export const scan = {
  modes: {
    single: { title: "Fota en pryl", short: "En sak, färdig annons", description: "Ta en bild så skriver vi annonsen och föreslår ett pris." },
    photos: { title: "Fota flera prylar", short: "Upp till 30 bilder", description: "Ladda upp en hög med bilder — vi grupperar ihop dem per pryl." },
    video: { title: "Videoskanning", short: "Filma ett rum", description: "Filma i upp till 60 sekunder så listar vi allt vi hittar." },
    deep: { title: "Djupskanning", short: "Expertens värdering", description: "Vi granskar en enskild pryl djupare: modell, skick och verkliga slutpriser ger en säkrare värdering." },
  },
  capture: {
    cameraTitle: "Ta kort på din pryl",
    chooseTitle: "Hur vill du lägga till bilden?",
    cameraDescription: "Håll prylen i bild och tryck på knappen. Du kan ta flera kort.",
    chooseDescription: "Använd enhetens kamera, välj en fil eller dra och släpp bilderna här.",
    takeWithCamera: "Ta kort med kameran",
    chooseDevice: "Välj från enheten",
    dropHint: "…eller dra och släpp bilderna i den här rutan.",
    retry: "Försök igen",
    chooseComputer: "Välj bilder från datorn",
    starting: "Startar kameran…",
    shotAlt: "Kort {{count}}",
    removeShot: "Ta bort kortet",
    takeShot: "Ta kort",
    back: "Tillbaka",
    usePhoto: "Använd bilden",
    useShots: "Använd {{count}} bilder",
    embeddedError: "Webbläsaren släpper inte fram kameran här. Öppna sajten i en egen flik och försök igen, eller välj bilder från datorn.",
    cameraError: "Vi kunde inte komma åt kameran. Tillåt kameran i webbläsaren och försök igen, eller välj bilder från datorn.",
    frameError: "Kameran hann inte ge en bild. Vänta någon sekund och tryck igen.",
    doneFrameError: "Kameran hann inte ge en bild. Tryck på Ta kort igen om en stund.",
    shotsCounter: "{{count}} av {{max}} bilder",
    limitReached: "Din nivå tillåter max {{max}} bilder per annons.",
    limitReachedUpgrade: "Gratis har {{max}} bilder per annons. Uppgradera till Plus för 6 bilder.",
    limitUpgradeLink: "Se nivåer och priser",
    clippedBody: "Du valde {{count}} bilder – bara de {{max}} första får plats.",
    clippedConfirm: "Fortsätt med de {{max}} första",
    clippedCancel: "Välj om",
  },
} as const;
